export default "/template/resource//static/media/gonganbeian.0c577066.png";